import React, {
  useState,
  useEffect
} from 'react';

import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import {
  Divider,
  Collapse,
  Badge,
  Button,
  IconButton,
  ListSubheader,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  StepContent,
  Typography,
  Tooltip,
  colors,
  ButtonBase,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteIcon from '@material-ui/icons/Delete';

import {
  DateTimeView,
  DocumentView,
  ProfileChip,
} from '../../general';

import {
  Thesis,
  ThesisSharedDocument,
} from '../../../types';

import localization from '../../../utils/localizations';
import {
  BaseAPI,
} from '../../../data/BaseAPI';

const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
    marginTop: 20,
    marginBottom: 20,
  },
  table: {

  },
  rowNumber: {
    fontWeight: 'bold',
    color: '#cecece',
  },
  itemMargin: {
    marginRight: 5,
    marginTop: 5,
    marginBottom: 5,
  },
}));


function ThesisSharedDocuments(props: {thesisId: string; collapsed?: boolean; hideIfEmpty?: boolean;}) {
  const classes = useStyles();
  const [isCollapsed, setIsCollapsed] = useState(props.collapsed ? true : false);
  const [files, setFiles] = useState([] as ThesisSharedDocument[]);
  const [isLoading, setIsLoading] = useState(false);

  const loadFiles = async () => {
    const api = new BaseAPI();
    setIsLoading(true);

    try {
      const data: any = await api.get(`thesis-shared-documents/?thesis=${props.thesisId}`);
      if (data instanceof Array) {
        setFiles(data as ThesisSharedDocument[]);
      }
    } catch (error) {
      console.log(error);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    loadFiles();
  }, [props.thesisId]);

  if (props.hideIfEmpty && files.length === 0) return (<div />);

  return (
    <Paper className={classes.mainBody}>
      <ListSubheader style={{paddingLeft: 8}}>{localization.documents}</ListSubheader>

      <TableContainer className={classes.table}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>{localization.file}</TableCell>
              <TableCell>{localization.kind}</TableCell>
              <TableCell>{localization.uploadedBy}</TableCell>
              <TableCell>{localization.date}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {files.map((f, i) => {
              return (
                <TableRow key={`shared-doc-${f.id}`}>
                  <TableCell><span className={classes.rowNumber}>{(i+1)}</span></TableCell>
                  <TableCell component="th" scope="row">
                    <DocumentView doc={f.file} />
                  </TableCell>
                  <TableCell>{f.kind}</TableCell>
                  <TableCell>
                    {!!f.created_by &&
                    <ProfileChip
                      key={`userchip-${i}-${f.created_by.id}`}
                      profile={f.created_by}
                      className={classes.itemMargin}
                    />}
                  </TableCell>
                  <TableCell align="right">
                    <DateTimeView value={f.updated_at} chip />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export {ThesisSharedDocuments};
